// Geometri för inloppspilar på urtavlan (dial-background.png, 281×283 px).
// Kompassens mitt ≈ (140, 128). 0° = rakt ner (Utlopp),
// växande vinkel moturs: 90° = vänster, 180° = upp, 270° = höger.
// Riktningsvektor för vinkeln θ: (-sin θ, cos θ) i skärmkoordinater (x höger, y ner).

const CX = 140
const CY = 128
const R_TAIL = 132 // pilens yttre ände – utanför gradsiffrorna
const R_HEAD = 12 // pilens spets – nästan ända in till centrum
const R_LABEL = 132 // nummerbricka vid pilens yttre ände, utanför gradsiffrorna
const HEAD_LEN = 12 // pilspetsens längd
const HEAD_HALF_W = 5 // pilspetsens halva bredd

// Returnerar en pil per inlopp (items[0] = Utlopp hoppas över) som har en
// giltig, ifylld vinkel. Varje pil innehåller linje, pilspets-polygon och
// koordinat för nummerbricka – i bildens pixelkoordinater.
export function computeInletArrows(items) {
  const arrows = []
  if (!items) return arrows

  items.forEach((item, idx) => {
    if (idx === 0) return // Utlopp finns redan tryckt på bilden
    if (item.vinkel === '' || item.vinkel == null) return
    const val = parseFloat(item.vinkel)
    if (isNaN(val)) return

    const rad = (val * Math.PI) / 180
    const dx = -Math.sin(rad)
    const dy = Math.cos(rad)

    const tailX = CX + R_TAIL * dx
    const tailY = CY + R_TAIL * dy
    const headX = CX + R_HEAD * dx
    const headY = CY + R_HEAD * dy

    // Pilen pekar inåt mot centrum (färdriktning = (-dx, -dy)).
    // Linjen slutar vid pilspetsens bas så den inte sticker ut genom spetsen.
    const baseX = headX + HEAD_LEN * dx
    const baseY = headY + HEAD_LEN * dy
    const p1x = baseX + HEAD_HALF_W * dy
    const p1y = baseY - HEAD_HALF_W * dx
    const p2x = baseX - HEAD_HALF_W * dy
    const p2y = baseY + HEAD_HALF_W * dx

    arrows.push({
      idx,
      x1: tailX,
      y1: tailY,
      x2: baseX,
      y2: baseY,
      head: `${headX},${headY} ${p1x},${p1y} ${p2x},${p2y}`,
      lx: CX + R_LABEL * dx,
      ly: CY + R_LABEL * dy,
    })
  })

  return arrows
}
